import React from "react"

const ServiceImageObjectFitField = ({ value = "cover", onChange }) => (
  <div className="relative box-border flex w-full shrink-0 flex-col content-stretch items-start justify-start gap-6 border-b border-builder-border-light px-0 pb-6 pt-0">
    <div className="relative box-border flex w-full shrink-0 flex-col content-stretch items-start justify-start gap-0.5 p-0 text-left leading-[0]">
      <div className="relative w-full shrink-0 font-['Manrope:Bold',_sans-serif] text-[16px] font-bold text-builder-primary">
        <p className="block leading-[24px]">Service photos</p>
      </div>
      <div className="relative w-full shrink-0 font-['Manrope:Regular',_sans-serif] text-[14px] font-normal text-builder-secondary">
        <p className="block leading-[20px]">
          Choose how photos fill their image area across every layout in this section.
        </p>
      </div>
    </div>
    <div className="flex flex-col gap-3">
      <label className="flex cursor-pointer items-center gap-3">
        <input
          type="radio"
          name="serviceImageObjectFit"
          value="cover"
          checked={value !== "contain"}
          onChange={() => onChange("cover")}
          className="size-6 cursor-pointer accent-builder-secondary"
        />
        <span className="font-['Manrope:Regular',_sans-serif] text-[16px] font-normal leading-[24px] text-builder-primary">
          Fill — crop to cover the image area
        </span>
      </label>
      <label className="flex cursor-pointer items-center gap-3">
        <input
          type="radio"
          name="serviceImageObjectFit"
          value="contain"
          checked={value === "contain"}
          onChange={() => onChange("contain")}
          className="size-6 cursor-pointer accent-builder-secondary"
        />
        <span className="font-['Manrope:Regular',_sans-serif] text-[16px] font-normal leading-[24px] text-builder-primary">
          Fit — show the full photo with letterboxing
        </span>
      </label>
    </div>
  </div>
)

export default ServiceImageObjectFitField
